export const getAuthToken = () => `Bearer ${localStorage.getItem('token')}`;

export const getHostSubdomain = () => window.location.hostname.split('.')[0];
